import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { setLoading } from "../../features/responseSlice";
import useMerchantPortalAxios from "../../utils/axios";
import useNewGenerateToken from "../authentication/GenerateToken";
import useNewLoginAPI from "./loginAPI";

export default function useMerchantSelection() {
  const client = useMerchantPortalAxios();
  const dispatch = useDispatch();
  const { generateRefreshToken } = useNewGenerateToken();
  const { CheckQrStatus } = useNewLoginAPI();

  async function selectEntity(entity) {
    const nextEntityId = entity?.MerchantID || entity?.LegalEntityID;
    if (!nextEntityId) return;

    try {
      dispatch(setLoading("globalPending"));

      await client.post("/v1/MerchantInformation/SaveUserEmployeeSelectedMerchant", {
        SessionID: sessionStorage.getItem("SessionID"),
        NewEntityID: nextEntityId,
      });

      sessionStorage.setItem("EntityID", nextEntityId);
      sessionStorage.setItem(
        "EntityName",
        entity?.MerchantName || entity?.LegalEntityName || "",
      );
      sessionStorage.setItem(
        "MerchantIconURL",
        entity?.MerchantIconURL ||
          entity?.MerchantIconUrl ||
          entity?.LegalEntityIconUrl ||
          "",
      );
      sessionStorage.setItem(
        "EntityURL",
        entity?.MerchantIconURL ||
          entity?.MerchantIconUrl ||
          entity?.LegalEntityIconUrl ||
          "",
      );
      sessionStorage.setItem("navClick", "Overview");

      await generateRefreshToken(
        sessionStorage.getItem("SessionID"),
        sessionStorage.getItem("RefreshToken"),
      );
      await CheckQrStatus(null, null);
    } catch {
      toast.error("An Error has occurred while changing merchant!");
    } finally {
      dispatch(setLoading("idle"));
    }
  }

  return { selectEntity };
}
